import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, Typography, useTheme } from '@mui/material';

type PropTypes = {
  close: () => void;
  handlePlayPracticeGameClick: () => void;
  open: boolean;
};

export const RecommendPracticeGameDialog = ({
  close,
  handlePlayPracticeGameClick,
  open,
}: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog open={open}>
      <DialogTitle>Before playing a Daily...</DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack spacing={2}>
          <Typography>We recommend playing a practice game first.</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          CANCEL
        </Button>
        <Button
          variant="contained"
          onClick={handlePlayPracticeGameClick}
          fullWidth
        >
          Play PRACTICE GAME
        </Button>
      </DialogActions>
    </Dialog>
  );
};
